module.exports = __webpack_public_path__ + "img/social-data-logo.10177180.svg";